import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IFinanceAccount } from 'src/app/finance/models/finance-account.model';
import { FinancialAccount, IGroup } from 'src/app/finance/models/group.model';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private http: HttpClient) { }

  getAllAccounts() {
    return this.http.get<any>(`${environment.financeURl}FinancialAccount?accountType=0&showBalance=false`);
  }

  fetchAllAccounts(isAscending) {
    return this.http.get<any>(`${environment.financeURl}FinancialAccount?accountType=0&IsAscending=${isAscending}`);
  }

  getAllAccountsWithPagination(data) {
    let params = new HttpParams();
    params = !data?.pageNo ? params : params.append("PageNumber", data?.pageNo);
    params = !data?.pageSize ? params : params.append("PageSize", data?.pageSize);
    params = !data?.searchValue ? params : params.append("SearchValue", data?.searchValue);
    params = !data?.searchColumns ? params : params.append("SearchColumns", data?.searchColumns);
    params = !data?.sortBy ? params : params.append("SortBy", data?.sortBy);
    params = !data?.isAscending ? params : params.append("IsAscending", data?.isAscending);
    params = !data?.filter ? params : params.append("filter", data?.filter);
    params = params.append("isActive", data?.isActive);
    params = params.append("showBalance", data?.showBalance);
    
    return this.http.get<any>(`${environment.financeURl}FinancialAccount?accountType=0`, { observe: 'response', params })
      .toPromise()
      .then(res => ({
        inventory: res.body,
        headers: JSON.parse(res.headers.get('x-pagination'))
      }));
  }


  getAccountGroups(accountTypeId) {
    return this.http.get<any>(`${environment.financeURl}FinancialAccountType?parentAccountTypeId=${accountTypeId}`);
  }

  deleteAccount(id, financialAccountId?) {
    let params = new HttpParams();
    params = !financialAccountId ? params : params.append("financialAccountId", financialAccountId);
    return this.http.delete<any>(`${environment.financeURl}FinancialAccount/${id}`, {params});
  }

  addAccount(data) {
    return this.http.post<any>(`${environment.financeURl}FinancialAccount`, data)
      .toPromise()
      .then(res => res);
  }

  saveAccount(data: IFinanceAccount) {
    return this.http.post<any>(`${environment.financeURl}FinancialAccount`, data);
  }

  editAccount(data: IFinanceAccount) {
    return this.http.put<any>(`${environment.financeURl}FinancialAccount`, data);
  }

  updateAccount(data) {
    return this.http.put<any>(`${environment.financeURl}FinancialAccount`, data)
      .toPromise()
  }

  // checkAccount(accountId) {
  //   return this.http.get<any>(`${environment.inventoryURl}Product/CheckAccountProductAssociation?financialAccountId=${accountId}`);
  // }
  
  checkAccount(accountId) {
    return this.http.get<any>(`${environment.financeURl}FinancialAccount/CheckProductAccountAssociation?financialAccountId=${accountId}`);
  }

  checkNumber(accTypeId, number, financialAccId = 0, name) {
    return this.http.get<any>(`${environment.financeURl}FinancialAccount/CheckFinancialNumberValidity?accounttype=${accTypeId}&number=${number}&financialAccountId=${financialAccId}&name=${name}`);
  }

  saveGroup(data: IGroup) {
    return this.http.post<any>(`${environment.financeURl}FinancialAccountType`, data);
  }

  saveFinancialAccountNumber(operator: any, data: FinancialAccount[]) {
    return this.http.post<any>(`${environment.financeURl}FinancialAccount/FinancialSetupSave`, data, {
      params: operator ? { operatorFinance: operator } : {}
    });
  }
}
